import React from 'react';

const Affilate = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.28936 10.0026C2.28936 5.74439 5.74133 2.29242 9.99956 2.29242C14.2578 2.29242 17.7097 5.74439 17.7097 10.0026C17.7097 10.6692 17.6253 11.3151 17.4669 11.9306L18.6777 12.2423C18.8621 11.5258 18.9601 10.7752 18.9601 10.0026C18.9601 5.05386 14.9483 1.04211 9.99956 1.04211C5.05081 1.04211 1.03906 5.05386 1.03906 10.0026C1.03906 14.9514 5.05081 18.9631 9.99956 18.9631C10.3015 18.9631 10.6002 18.9481 10.8949 18.9189L10.7713 17.6747C10.5177 17.6999 10.2602 17.7128 9.99956 17.7128C8.27716 17.7128 6.68667 17.148 5.40318 16.1936C6.50978 14.7883 8.20313 13.9618 10.0018 13.9618H10.8354V12.7115H10.0018C7.84124 12.7115 5.8059 13.6941 4.46233 15.3679C3.11727 13.98 2.28936 12.088 2.28936 10.0026ZM10.0002 4.79294C8.2872 4.79294 6.93672 6.25128 7.06811 7.95927L7.13327 8.80631C7.2485 10.3044 8.49771 11.4612 10.0002 11.4612C11.5028 11.4612 12.752 10.3044 12.8672 8.80631L12.9324 7.95927C13.0637 6.25128 11.7133 4.79294 10.0002 4.79294ZM8.31473 7.86338C8.2392 6.88155 9.01551 6.04324 10.0002 6.04324C10.985 6.04324 11.7613 6.88155 11.6857 7.86338L11.6206 8.71041C11.5555 9.55711 10.8494 10.2109 10.0002 10.2109C9.15104 10.2109 8.44501 9.55711 8.37988 8.71042L8.31473 7.86338ZM15.034 12.5674C15.1781 12.2299 15.6565 12.2299 15.8006 12.5674L16.5115 14.2328L18.282 14.4341C18.6335 14.4741 18.7785 14.9061 18.5224 15.15L17.1877 16.4212L17.5511 18.2456C17.6219 18.6007 17.2373 18.8709 16.9272 18.684L15.4173 17.7737L13.9074 18.684C13.5973 18.8709 13.2128 18.6007 13.2835 18.2456L13.6469 16.4212L12.3122 15.15C12.0561 14.9061 12.2012 14.4741 12.5526 14.4341L14.3231 14.2328L15.034 12.5674Z",
      fill: "white"
    }
  )
);

export { Affilate };
//# sourceMappingURL=Affilate.js.map
